module.exports = __webpack_public_path__ + "fonts/SofiaProRegular.1f73bfb5.ttf";